import { render, staticRenderFns } from "./AddCharge.vue?vue&type=template&id=b9836d8c&"
import script from "./AddCharge.vue?vue&type=script&lang=js&"
export * from "./AddCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddCharge.vue"
export default component.exports